import { useEffect, useState } from "react";
import { uploadTelemetryService } from "@/utils/uploadTelemetry";

export const useUploadTelemetry = (uploadId) => {
  const [state, setState] = useState(() =>
    uploadTelemetryService.getState(uploadId)
  );

  useEffect(() => {
    if (!uploadId) {
      return undefined;
    }
    const unsubscribe = uploadTelemetryService.subscribe(uploadId, setState);
    return () => {
      unsubscribe?.();
    };
  }, [uploadId]);

  return state;
};
